import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import AdminGateway from '~apis/admin';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';
import UtilFunctions from '~utils/functions';
import { AuthUserStatusEnum } from '~utils/enums';

export default function* watchGetAdminListing(api: AdminGateway): SagaWatcherReturnType {
    yield takeEvery('admin/adminGetAdminListingAttempt', handleGetAdminListing, api);
}

function* handleGetAdminListing(api: AdminGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const { index, filters: { status, branchCode, email } } = reduxState.admin.adminListing;
    const convertedStatus = UtilFunctions.Misc.getEnumValueByKey(AuthUserStatusEnum, status);

    if (!index && index !== 0) {
        yield put(combinedActions.adminGetAdminListingFailure(ErrorMessages.GenericRequiredFieldNotFilledIn));
        toast.error(ErrorMessages.GenericRequiredFieldNotFilledIn);
        return;
    }

    // if status is passed but not a valid status
    if (status && !convertedStatus) {
        yield put(combinedActions.adminGetAdminListingFailure(ErrorMessages.FilterInvalidStatusError));
        toast.error(ErrorMessages.FilterInvalidStatusError);
        return;
    }

    const response = yield* call([api, api.getAdminListing], {
        authToken,
        index,
        status: convertedStatus,
        branchCode: branchCode || undefined,
        email: email || undefined,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.adminGetAdminListingFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.adminGetAdminListingSuccess(response.data));
    }
}
